var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 101,
    viewBox: "0 0 90 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 22.9215C17.1429 29.0007 19.551 34.8309 23.8376 39.1295C28.1241 43.4281 33.9379 45.8431 40 45.8431C46.0621 45.8431 51.8759 43.4281 56.1624 39.1295C60.449 34.8309 62.8571 29.0007 62.8571 22.9215C62.8571 16.8424 60.449 11.0122 56.1624 6.71356C51.8759 2.41494 46.0621 0 40 0C33.9379 0 28.1241 2.41494 23.8376 6.71356C19.551 11.0122 17.1429 16.8424 17.1429 22.9215ZM34.0179 56.0861L37.3393 61.6374L31.3929 83.8248L24.9643 57.5187C24.6071 56.0682 23.2143 55.1191 21.7679 55.4952C9.26786 58.629 0 69.9823 0 83.5024C0 86.5467 2.46429 89 5.48214 89H74.5179C77.5536 89 80 86.5288 80 83.5024C80 69.9823 70.7321 58.629 58.2321 55.4952C56.7857 55.137 55.3929 56.0861 55.0357 57.5187L48.6071 83.8248L42.6607 61.6374L45.9821 56.0861C47.125 54.17 45.75 51.7525 43.5357 51.7525H36.4821C34.2679 51.7525 32.8929 54.1879 34.0357 56.0861H34.0179Z",
    fill: "#0A3575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 22.9215C17.1429 29.0007 19.551 34.8309 23.8376 39.1295C28.1241 43.4281 33.9379 45.8431 40 45.8431C46.0621 45.8431 51.8759 43.4281 56.1624 39.1295C60.449 34.8309 62.8571 29.0007 62.8571 22.9215C62.8571 16.8424 60.449 11.0122 56.1624 6.71356C51.8759 2.41494 46.0621 0 40 0C33.9379 0 28.1241 2.41494 23.8376 6.71356C19.551 11.0122 17.1429 16.8424 17.1429 22.9215ZM34.0179 56.0861L37.3393 61.6374L31.3929 83.8248L24.9643 57.5187C24.6071 56.0682 23.2143 55.1191 21.7679 55.4952C9.26786 58.629 0 69.9823 0 83.5024C0 86.5467 2.46429 89 5.48214 89H74.5179C77.5536 89 80 86.5288 80 83.5024C80 69.9823 70.7321 58.629 58.2321 55.4952C56.7857 55.137 55.3929 56.0861 55.0357 57.5187L48.6071 83.8248L42.6607 61.6374L45.9821 56.0861C47.125 54.17 45.75 51.7525 43.5357 51.7525H36.4821C34.2679 51.7525 32.8929 54.1879 34.0357 56.0861H34.0179Z",
    fill: "#0A3575"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6658_51235)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61H82C87.3333 61 90 63.6667 90 69V93C90 98.3333 87.3333 101 82 101H58C52.6667 101 50 98.3333 50 93V69C50 63.6667 52.6667 61 58 61Z",
    fill: "#0A3575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82 61H70.87C66.0947 62.1645 61.6853 64.5018 58.0412 67.8003C54.397 71.0987 51.6332 75.254 50 79.89L50 93C50 95.1217 50.8429 97.1566 52.3431 98.6569C53.8434 100.157 55.8783 101 58 101H82C84.1217 101 86.1566 100.157 87.6569 98.6569C89.1571 97.1566 90 95.1217 90 93V69C90 66.8783 89.1571 64.8434 87.6569 63.3431C86.1566 61.8429 84.1217 61 82 61Z",
    fill: "#0A3575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.001 61H81.851C77.6389 61.9108 73.6775 63.7334 70.2454 66.3396C66.8133 68.9458 63.9939 72.2724 61.9855 76.0852C59.9771 79.898 58.8285 84.1046 58.6204 88.409C58.4123 92.7134 59.1497 97.0112 60.781 101H82.001C84.1227 101 86.1575 100.157 87.6578 98.6569C89.1581 97.1566 90.001 95.1217 90.001 93V69C90.001 66.8783 89.1581 64.8434 87.6578 63.3431C86.1575 61.8429 84.1227 61 82.001 61Z",
    fill: "#0A3575"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4199 89.1684C69.4149 93.2403 70.256 97.2688 71.8899 100.998H81.9999C84.1217 100.998 86.1565 100.156 87.6568 98.6553C89.1571 97.155 89.9999 95.1202 89.9999 92.9984V68.9984C89.9998 67.6984 89.6829 66.4179 89.0765 65.2679C88.4701 64.1179 87.5926 63.133 86.5199 62.3984C81.4128 64.7643 77.0891 68.5419 74.0591 73.2853C71.0292 78.0287 69.4194 83.5399 69.4199 89.1684Z",
    fill: "#0A3575"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6658_51235)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6658_51235",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 72,
    width: 18,
    height: 18
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.875 74.625C62.875 74.3266 62.9935 74.0405 63.2045 73.8295C63.4155 73.6185 63.7016 73.5 64 73.5H73C73.2984 73.5 73.5845 73.6185 73.7955 73.8295C74.0065 74.0405 74.125 74.3266 74.125 74.625V88.5H64C63.7016 88.5 63.4155 88.3815 63.2045 88.1705C62.9935 87.9595 62.875 87.6734 62.875 87.375V74.625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.125 81C74.125 80.8011 74.204 80.6103 74.3447 80.4697C74.4853 80.329 74.6761 80.25 74.875 80.25H76.375C76.5739 80.25 76.7647 80.329 76.9053 80.4697C77.046 80.6103 77.125 80.8011 77.125 81V87.375C77.125 87.6734 77.0065 87.9595 76.7955 88.1705C76.5845 88.3815 76.2984 88.5 76 88.5H74.125V81Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.125 76.5H68.125M65.125 79.125H69.625",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6658_51235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 72H79V90H61V72Z",
    fill: "white"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 61.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6658_51235"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 61,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6658_51235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(61 72)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.a2f20f213855d1a3f2b6688897297076.svg";
export { ForwardRef as ReactComponent };